import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useSelector } from "react-redux";
import { Mixpanel } from "../../../config/Mixpanel";
import Constants from "../../../common/constants";

const RecruiterButton = ({ requestInterviewRef, requestCvRef ,handlerPersonalise , setIsRequestCv , setIsRequestInterview }) => {
  const is_cv_requested = useSelector(
    (store) => store?.certificateVerification?.is_cv_requested
  );
  const is_interview_requested = useSelector(
    (store) => store?.certificateVerification?.is_interview_requested
  );
  const certificateData = useSelector(
    (store) => store?.certificateVerification?.certificateData
  );
  const userDetails = useSelector((store) => store?.certificateVerification?.userInfo);

  if (!is_cv_requested) {
    return (
      <button className="w-full rounded-lg bg-[#7FC241] py-3 px-3 text-center text-[16px] font-medium text-[#121212] md:text-[18px]" onClick={(e)=> {
        
        Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_RECRUITER_PAGE_REQUEST_CV_BUTTON_CLICKED);
        setIsRequestCv(true); requestCvRef?.current?.scrollIntoView({behavior: "smooth", block: 'center'})}}>
        Request {certificateData?.name?.split(" ")[0]}’s CV & LinkedIn{" "}
      </button>
    );
  } else if (!is_interview_requested) {
    return (
      <button className="w-full rounded-lg bg-[#7FC241] py-3 px-3 text-center text-[16px] font-medium text-[#121212] md:text-[18px]" onClick={(e)=>{
        
        
         Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_RECRUITER_PAGE_REQUEST_INTERVIEW_BUTTON_CLICKED);
        
        setIsRequestInterview(true); requestInterviewRef?.current?.scrollIntoView({behavior: "smooth", block: 'center'})}}>
        Want To Interview {certificateData?.name?.split(" ")[0]}? Request Now{" "}
      </button>
    );
  } else {
    return (
      <button className="w-full rounded-lg bg-[#7FC241] py-3 px-3 text-center text-[16px] font-medium text-[#121212] md:text-[18px]" onClick={(e)=> 
      
      {
      Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_RECRUITER_PAGE_BUILD_PERSONALIZED_COURSE_CLICKED);
      handlerPersonalise({utm_medium : 'build-course' , utm_source : 'certificate-verification'})
      }}>
        Build Your Own Course Today{" "}
        <FontAwesomeIcon icon={faArrowRight} size="md" className="ml-1" />
      </button>
    );
  }
};

export default RecruiterButton;
